import styled from "astroturf";

import { Section as SectionUI } from "../styles";

export const Section = styled(SectionUI)`
  height: 31rem;
  position: relative;
`;
